import React from 'react';
import { HeaderDetail } from '../components/HeaderDetail';

export function Header({ setSearch, lang, search }) {
 return (
     <HeaderDetail search={search} lang={lang} setSearch={setSearch}></HeaderDetail>
 )
}